import React from 'react';
import { Card, Form, Space, Input } from 'antd';

import { formItemLayout } from '../Common';
import { isEmpty, invalidHost } from 'script/common';

const MongodbConnection = ({t, apps, settingKey, settingData, onSave, alertMessage}) => {
	const initialValues = {
		['data']: settingData
	}

	const onFinish = (e) => {
		let value = [];

		Object.keys(e.data).forEach((app) => {
			settingKey.keyList.map((list) => {
				let defaultValue = null;
				let initValue = null;
				if (!isEmpty(initialValues.data[app])) {
					defaultValue = initialValues.data[app][list.value].default
					initValue = initialValues.data[app][list.value].value
				}

				let setValue = e.data[app][list.value].value
				if (list.value === "mongodbHost") {
					if (invalidHost(setValue)) return alertMessage("The Host format is incorrect.");
				}

				value.push({
					key: list.value + "_" + app,
					value: (defaultValue === setValue) ? null : setValue
				})
			})
		})

		if (!isEmpty(value)) {
			onSave(false, value)
		}
	}


	return (
		<Form {...formItemLayout} onFinish={onFinish} initialValues={initialValues}>
			<Card title={t(settingKey.key)} key={settingKey.key} style={{ margin: 20 }}>
				{ apps.map((app, i) => {
					return (
						<Card type="inner" key={app.key} title={t(app.key)} style={{ margin: 20 }}>
							{ settingKey.keyList.map((list,i) => {
								return (
									<Form.Item 
										key ={list.key}
										label={t(list.key)}
										name={['data', app.value, list.value, 'value']}
										rules={[{ required: true, message: 'Please input value!' }]}
										width="20%"
									>
										{ ((t(list.key)) === 'Password') ? <Input.Password  visibilityToggle={false}/> : <Input />}
									</Form.Item>
								)
							})}
						</Card>
					)
				})}
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
		</Form>
	)
}

export default MongodbConnection